/**
 * @Author: WeiZisen
 * @Date: 2021-04-07 10:30:55
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-04-07 10:38:06
 * @Description: 验证规则-库位定义
 * @FilePath: \Vue_RebarProcess\src\validate\project-data\position.js
 */
export let rules = {
  name: [{ required: true, message: '请填写库位名称', trigger: 'blur' }],
  code: [{ required: true, message: '请填写库位编码', trigger: 'blur' }],
  length: [{ required: true, message: '请填写库位长', trigger: 'blur' }],
  width: [{ required: true, message: '请填写库位宽', trigger: 'blur' }],
  height: [{ required: true, message: '请填写库位高', trigger: 'blur' }],
}
